import React from "react";

import { DeviceReference } from "modules/devices";

import { useSiteDataByUnit, flattenSiteDataByUnit } from "../useSiteData";

import { AggregatedDeviceCard } from "./AggregatedDeviceCard";
import { QuickLink } from "./QuickLink";

export const SiteCard = ({
  siteId,
  devices,
  getNow = Date.now,
}: {
  siteId: string;
  devices: DeviceReference[];
  getNow: () => number;
}) => {
  const { latestDataByUnit } = useSiteDataByUnit(siteId);

  return (
    <AggregatedDeviceCard
      title={siteId}
      linkTo={`/sites/${siteId}`}
      dataTestId={`sitecard-${siteId}`}
      devices={devices}
      deviceData={flattenSiteDataByUnit(latestDataByUnit)}
      getNow={getNow}
      quickLinks={
        <>
          <QuickLink to={`/sites/${siteId}/reports`}>Reports</QuickLink>
          <QuickLink to={`/sites/${siteId}/realtime`}>Real-time data</QuickLink>
          <QuickLink to={`/sites/${siteId}/command`}>Send Command</QuickLink>
        </>
      }
    />
  );
};
